import { render, staticRenderFns } from "./money.vue?vue&type=template&id=5208e07a&scoped=true"
import script from "./money.vue?vue&type=script&lang=js"
export * from "./money.vue?vue&type=script&lang=js"
import style0 from "./money.vue?vue&type=style&index=0&id=5208e07a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5208e07a",
  null
  
)

export default component.exports